import { addDays, format, parseISO, startOfWeek } from "date-fns";

export const toLocal = (d) => format(d, "yyyy-MM-dd'T'HH:mm");
export const toDay = (d) => format(d, "yyyy-MM-dd");
export const weekStartOf = (d) => startOfWeek(d, { weekStartsOn: 1 });
export const weekDays = (start) => Array.from({ length: 7 }, (_, i) => addDays(start, i));
export const minutesOf = (hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
};
export const minutesOfDate = (iso) => {
  const d = parseISO(iso);
  return d.getHours() * 60 + d.getMinutes();
};
export const fmtTime = (iso) => format(parseISO(iso), "HH:mm");

export function fmtDuration(min) {
  const h = Math.floor(min / 60);
  const m = min % 60;
  if (!h) return `${m}m`;
  return m ? `${h}h ${m}m` : `${h}h`;
}

export const fmtDeadline = (d) => (d ? format(parseISO(d), "EEE d MMM") : "No deadline");

export const hoursFor = (s, wd) => s.days?.[String(wd)] || { start: s.day_start, end: s.day_end, lunch_start: s.lunch_start, lunch_end: s.lunch_end };

export function defaultBlocks(d, s) {
  const wd = (d.getDay() + 6) % 7;
  if (!s.work_days.includes(wd)) return [];
  const h = hoursFor(s, wd);
  if (!h.lunch_start || !h.lunch_end || h.lunch_start >= h.lunch_end) return [{ start: h.start, end: h.end }];
  return [{ start: h.start, end: h.lunch_start < h.end ? h.lunch_start : h.end }, { start: h.lunch_end > h.start ? h.lunch_end : h.start, end: h.end }].filter((b) => b.start < b.end);
}

export const blocksFor = (d, s, overrides) => overrides[toDay(d)] ?? defaultBlocks(d, s);

export const hhmm = (min) => (min >= 1440 ? "23:59" : `${String(Math.floor(min / 60)).padStart(2, "0")}:${String(min % 60).padStart(2, "0")}`);

export const downloadFile = async (api, url, fallbackName) => {
  const res = await api.get(url, { responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || fallbackName;
  const link = document.createElement("a");
  link.href = URL.createObjectURL(res.data);
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
};
